"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.letterSpacingHelperStyle = void 0;

var _grid = require("../grid");

var letterSpacingHelperStyle = function letterSpacingHelperStyle(size) {
  return (0, _grid.map)(size, function (s) {
    return "letter-spacing: ".concat(s, "px;");
  });
};

exports.letterSpacingHelperStyle = letterSpacingHelperStyle;